//Polyfill
import "core-js";

//Can't resolve 'regenerator-runtime/runtime'が表示されたとき(async awaitを使う場合など)
//import  regeneratorRuntime  from  "regenerator-runtime" ;
import jQuery from "jquery";

const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

$(document).ready(function () {
  // .header-btnがクリックされたときの処理
  $(".header-btn").click(function () {
    // .header-btnと.header-spのopenクラスをトグル（追加/削除）
    $(".header-btn, .header-sp").toggleClass("open");
  });

  // .header-sp内のaタグがクリックされたときの処理
  $(".header-sp a").click(function () {
    // .header-btnと.header-spからopenクラスを削除
    $(".header-btn, .header-sp").removeClass("open");
  });

  $(".front-faq-box").on("click", function(e) {
    e.stopPropagation(); // パカパカ対策その1（親要素への伝播防止）

    // 自分以外の開いてる要素を閉じたい場合はこの辺追加するとよい（任意）
    // $(".front-faq-box--hide").not($(this).find(".front-faq-box--hide")).slideUp();
    // $(".front-faq-box").not(this).removeClass("active");

    // パカパカ対策その2（アニメーションの途中で再度クリックされても暴れないように）
    $(this).find(".front-faq-box--hide").stop(true, true).slideToggle();

    $(this).toggleClass("active");
  });
});

// 詳細検索の展開
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".front__sub--search--menu").forEach((menu) => {
    let nextElement = menu.nextElementSibling;

    // すべての label を取得してグループ化
    let labels = [];
    while (nextElement && nextElement.tagName === "LABEL") {
      labels.push(nextElement);
      nextElement = nextElement.nextElementSibling;
    }

    // 初期状態で展開しておく
    if (labels.length > 0) {
      labels.forEach((label) => {
        label.style.display = "inline-flex";
        label.style.opacity = "1";
      });
      menu.classList.add("active"); // メニューにもactiveクラスつけとく（必要なら）
    }

    // クリックで表示・非表示を切り替える
    menu.addEventListener("click", function () {
      let isVisible = labels[0].style.display === "inline-flex";
      labels.forEach((label) => {
        if (isVisible) {
          label.style.opacity = "0";
          setTimeout(() => {
            label.style.display = "none";
          }, 500);
        } else {
          label.style.display = "inline-flex";
          setTimeout(() => {
            label.style.opacity = "1";
          }, 10);
        }
      });

      this.classList.toggle("active");
    });
  });

  // チェックボックスの状態に応じて label に active クラスを追加・削除
  document.querySelectorAll(".feas_clevel_01 input[type='checkbox']").forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      let parentLabel = this.closest("label");
      if (parentLabel) {
        if (this.checked) {
          parentLabel.classList.add("active");
        } else {
          parentLabel.classList.remove("active");
        }
      }
    });
  });
});
